<form [formGroup]="form" (ngSubmit)="save()">
    <div class="tab-card">
        <div class="tab-card-header">
            <span class="tab-icon-badge" style="background:#ffccf0;"><img src="assets/img/icons/imss-tooth.svg" alt=""></span>
            <h5>IMSS</h5>
        </div>

        <div class="field-row">
            <div class="field-col">
                <label class="field-label">Tipo de empleado</label>
                <select class="field-select" formControlName="employee_type">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let e of employeeTypes" [value]="e">{{e}}</option>
                </select>
            </div>
            <div class="field-col">
                <label class="field-label">Registro patronal</label>
                <input type="text" class="field-input" formControlName="employer_registration">
            </div>
        </div>

        <div class="tab-imss-contract-box">
            <div class="d-flex align-items-center gap-2 mb-3">
                <img src="assets/img/icons/section-regimen-contratacion.svg" alt="" width="24" height="24">
                <strong style="color:#545454;">Detalles del contrato</strong>
            </div>
            <div class="d-flex gap-5 flex-wrap">
                <div>
                    <div class="field-label mb-1">Tipo de contrato</div>
                    <a href="javascript:void(0)" (click)="goToFiscal.emit()">{{employee?.contract_type || 'Sin definir'}}</a>
                </div>
                <div>
                    <div class="field-label mb-1">Fecha de inicio</div>
                    <app-date-picker class="field-input" formControlName="contract_start_date"></app-date-picker>
                </div>
                <div>
                    <div class="field-label mb-1">Fecha de vencimiento</div>
                    <app-date-picker class="field-input" formControlName="contract_end_date"></app-date-picker>
                </div>
            </div>
            <div class="d-flex align-items-center gap-2 mt-3">
                <i class="ti ti-help-circle" style="color:#f20cac;"></i>
                <span style="color:#f20cac;">Nota: El tipo de contrato se modifica desde la pestaña Fiscales</span>
            </div>
        </div>

        <div class="field-row">
            <div class="field-col">
                <label class="field-label">Tipo de jornada</label>
                <select class="field-select" formControlName="work_schedule_type">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let w of workScheduleTypes" [value]="w">{{w}}</option>
                </select>
            </div>
            <div class="field-col">
                <label class="field-label">Turno</label>
                <select class="field-select" formControlName="shift">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let s of shifts" [value]="s">{{s}}</option>
                </select>
            </div>
        </div>

        <div class="field-row">
            <div class="field-col">
                <label class="field-label">Unidad medica familiar</label>
                <input type="text" class="field-input" formControlName="medical_unit">
            </div>
        </div>

        <div class="field-checkbox-row">
            <input type="checkbox" id="alimony_discount" formControlName="alimony_discount">
            <label class="mb-0" for="alimony_discount">Descuento pensión alimenticia</label>
        </div>
    </div>

    <div class="tab-save-bar" *ngIf="canDo('Editar')">
        <button type="submit" class="btn btn-primary">Guardar cambios</button>
    </div>
</form>
